import { z } from "zod";

export const schema = z.object({
  comments: z
    .string()
    .min(1, "El comentario es obligatorio")
    .refine((val) => {
      return val.trim().length > 0;
    }, "El comentario no puede estar vacío"),
});

export type CancelInfractionFormData = z.infer<typeof schema>;
